import { Inject, Injectable } from '@angular/core';

import { FixturePage } from '@cds/betting-offer';
import { BetBuilderView, OptionMarketsRequest } from '@cds/betting-offer/bet-builder';
import { BetBuilderFixture } from '@cds/betting-offer/domain-specific/bet-builder';
import { MarketGroupConfig } from '@cds/betting-offer/grouping/bet-builder';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BetBuilderApi {
    private cdsApi: BaseCdsApi;

    constructor(@Inject(CDS_API_FACTORY) cdsApiServiceFactory: BaseCdsApiFactory) {
        this.cdsApi = cdsApiServiceFactory({ endpoint: '/betbuilder/fixtures' });
    }

    getFixtures(sport: number, skip?: number, take?: number, competitionId?: number): Observable<FixturePage | undefined> {
        return this.cdsApi.get<FixturePage>(`/${sport}`, { skip, take, competitionId });
    }

    getPromotedMarkets(sport: number, page?: number, size?: number, competitionId?: number): Observable<BetBuilderFixture[] | undefined> {
        return this.cdsApi.get<BetBuilderFixture[]>(`/pre-created/promoted/${sport}`, { page, size, competitionId });
    }

    getSportcastMarkets(request: OptionMarketsRequest): Observable<BetBuilderView | undefined> {
        return this.cdsApi.get<BetBuilderView>(`/sportcast/markets`, request);
    }

    getMarketGroupConfig(sportId: number): Observable<MarketGroupConfig | undefined> {
        return this.cdsApi.get<MarketGroupConfig>(`/sportcast/market-groups`, { sportId });
    }
}
